import Vue from 'vue'
import Vuex from 'vuex'

export default class {
    constructor() {
        Vue.use(Vuex);
        const state = {
					loading: true,
					error: false,
					socialData: null
				};
        const getters = {
					loading: state => {
						return state.loading
					},
					error: state => {
						return state.error
					},
					socialData: state => {
						return state.socialData
					}
				};
        const mutations = {
					setStateValue(state, payload) {
						state[payload.key] = payload.value;
					},
					setSocialData(state, payload) {
						state.socialData = payload;
					}
				};
        const actions = {
					loadSocialData({commit}, payload) {
						return new Promise(resolve => {
							fetch(payload)
							.then(response => response.json())
							.then(data => {
								commit('setSocialData', data)
							})
							.catch(error => {
								console.log(error);
								commit("setStateValue", { key: "error", value: "true" })
							})
							.finally(() => {
								setTimeout(() => {
									commit("setStateValue", { key: "loading", value: false });
									resolve();
								}, 750);
							});
						});
					}
				};

        this.store = new Vuex.Store({
            state,
            getters,
            mutations,
            actions
        });
    }
}
